import React from 'react'

type ArrowDownIconProps = {
  className?: string
}

const ArrowDownIcon = ({ className }: ArrowDownIconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#000"
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      ></path>
    </svg>
  )
}

export default ArrowDownIcon
